<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Kondisi Saat Ini {{devices.station}} - {{devices.location}}</v-card-title>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersCondition"
                  :items="periodic"
                  :items-per-page="5"
                  :calculate-widths="true"
                  :mobile-breakpoint="500"
                  item-key="station"
                  class="elevation-1"
                  hide-default-footer
                  disable-sort
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                  }"
                >
                <template v-slot:[`item.time`]="{ item }">
                  {{updateTime(item.time)}}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <span v-if="item.status==='active'">
                    <v-chip
                      color="success darken-1"
                    >
                      Aktif
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      Mati
                    </v-chip>
                  </span>
                </template>
                <template v-slot:[`item.condition`]="{ item }">
                  <span v-if="item.condition==='Hujan'">
                    <v-chip
                      color="success darken-1"
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                  <span v-else-if="item.condition==='Tidak Hujan'">
                    <v-chip
                      color="grey"
                      dark
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                </template>
                <template v-slot:[`item.voltage`]="{ item }">
                  <span v-if="parseFloat(item.voltage)>parseFloat(item.batLow)">
                    <v-chip
                      color="success darken-1"
                    >
                      {{item.voltage}}
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      {{item.voltage}}
                    </v-chip>
                  </span>
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Kondisi Historis {{devices.station}} - {{devices.location}}</v-card-title>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :items-per-page="10"
                  :calculate-widths="true"
                  :mobile-breakpoint="500"
                  :loading="tableLoad"
                  class="elevation-1"
                  item-key="did"
                  hide-default-footer
                  disable-pagination
                  disable-sort
                >
                <template v-slot:footer>
                  <v-divider class="my-3"></v-divider>
                  <v-row>
                    <v-col> 
                      <v-btn icon class="float-right mx-2" color="#757575" @click="page++;getData(page,itemsPerPage)">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                      <body-1 class="float-right mt-2 mx-2">
                        {{page}}
                      </body-1>
                      <span v-if="page==1">
                        <v-btn disabled icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage)">
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                      </span>
                      <span v-else>
                        <v-btn icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage)">
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                      </span>
                      <v-select
                        flat
                        single-line
                        dense
                        :items="[10,30,50]"
                        :value="10"
                        class="float-right mx-2"
                        v-model="itemsPerPage"
                        @change="getData(page,itemsPerPage)"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:[`item.start`]="{ item }">
                  {{updateTime(item.start)}}
                </template>
                <template v-slot:[`item.end`]="{ item }">
                  {{updateTime(item.end)}}
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "@/firebase/db.js"
import moment from 'moment'

  export default {
    name: 'DataPage',

    data: () => ({
      headers: [
          { text: 'Curah Hujan (mm)', value: 'curah' },
          { text: 'Waktu Awal', value: 'start' },
          { text: 'Waktu Akhir', value: 'end' },
      ],
      historical:[],
      data:[],
      tableLoad:true,
      devices:{},
      offset:0,
      lastData:{},
      beforeData:[],
      firstData:{},
      lastPage:1,
      page:1,
      itemsPerPage:10,
      infoTime:{},
      batLow:{},
      periodic:[],
      headersCondition: [
        { text: 'Tegangan Batre', value: 'voltage' },
        { text: 'Status Alat', value: 'status' },
        { text: 'Rekap Hari Ini (mm)', value: 'rainvol' },
        { text: 'Kondisi Saat Ini', value: 'condition' },
        { text: 'Signal', value: 'signal' },
      ],
    }),
    async mounted () {
      let loader = this.$loading.show()
      const date=new Date();
      this.offset=date.getTimezoneOffset()/(-60)
      await db.collection('device').doc(this.$route.params.mac).get().then((doc) => {
        this.devices={
          id:doc.id, 
          ...doc.data()
        }
      })

      await db.collection('setting').doc(this.$route.params.mac).get().then((doc) => {
        this.infoTime={id:doc.id, infotime:doc.data().infotime}
        this.batLow={id:doc.id, volt:doc.data().voltLow}
      })
      
      await this.getData(1,this.itemsPerPage)

      db.collection('periodic').doc(this.$route.params.mac).onSnapshot((doc) => {
        let time=Date.now()/1000
        this.periodic=[]
        this.periodic.push({id:doc.id, ...doc.data()})
        this.periodic[0].location=this.devices.location
        this.periodic[0].station=this.devices.station
        this.periodic[0].condition=this.devices.condition
        this.periodic[0].updateTime=parseInt(this.infoTime.infotime)*2*60;
        this.periodic[0].batLow=this.batLow.volt
        if(time-parseInt(this.periodic[0].time)>this.periodic[0].updateTime) {
          this.periodic[0].status='In-Active'
          this.periodic[0].condition='N/A'
        } else {
          this.periodic[0].status='active'
        }               
        loader.hide()
      })
    },
    methods: {
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      async getData (page,items) {
        this.tableLoad= true 
        var dataRef = db.collection('notification').where('notif','==','stop').where('id','==',this.$route.params.mac).orderBy("time","desc").limit(items)
        //forward
        if (page>this.lastPage && (page!=1)) {
          this.beforeData.push(this.firstData)
          this.beforeData[page-1]=this.firstData
          this.lastPage=page
          dataRef = db.collection('notification').where('notif','==','stop').where('id','==',this.$route.params.mac).orderBy("time","desc").startAfter(this.lastData).limit(items)
        } 
        // First Page
        else if (page==1) {
          this.lastPage=page
          dataRef = db.collection('notification').where('notif','==','stop').where('id','==',this.$route.params.mac).orderBy("time","desc").limit(items)
        } 
        //backward
        else if (page<this.lastPage) {
          this.lastPage=page
          console.log(page)
          dataRef = db.collection('notification').where('notif','==','stop').where('id','==',this.$route.params.mac).orderBy("time","desc").limit(items).startAt(this.beforeData[page])
        }
        await dataRef.get().then((collectionSnapshot) => {
          let i=0
          this.historical=[]
          let count=0
          collectionSnapshot.forEach((doc) => {
            if (count==0) {
              this.firstData=doc
              count++
            }
            this.historical.push({curah:doc.data().curah})
            this.historical[i].did=doc.id
            this.historical[i].id=doc.data().id
            this.historical[i].end = doc.data().time
            this.historical[i].start = doc.data().start
            this.historical[i].location=this.devices.location
            this.historical[i].station=this.devices.station
            this.lastData=doc;
            i++;
          });
          this.data=this.historical
          this.tableLoad=false
        })  
      },
    }
    // computed: {
    //   dateRangeText () {
    //     return this.dates.join(' ~ ')
    //   },
    // },
  }
</script>
